<template>
  <div class='card video-card'>
    <BSkeletonImg height="">
    </BSkeletonImg>
    <div class="card-body video-card-body p-0 pt-3">
      <BSkeleton animation="wave" width="85%"></BSkeleton>
      <BSkeleton animation="wave" width="55%"></BSkeleton>
      <BSkeleton animation="wave" width="70%"></BSkeleton>
    </div>
  </div>
</template>

<script>
import { BSkeletonImg, BSkeleton } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

export default {
  components: {
    BSkeletonImg,
    BSkeleton
  }
}
</script>

<style>
   /* for safari */
 .b-aspect-content {
   display: flex;
 }
   /* for safari */
 .b-skeleton-img {
   height: unset;
 }
</style>
